import { Input as InputAntD, InputProps } from 'antd';
import { FC } from 'react';

export const Input: FC<InputProps> = (props) => {
	return <InputAntD {...props} />;
};
